import styled from 'styled-components';

export const HeaderWithColumns = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
`;
